/**
 * Created by liux on 2018/5/3.
 * @param Object,{
 *  testRule: [Array]
 *  [{
 *   key:'要检测的数据'|[string]，
 *   verify(value)：检测函数,value 为对应key的值 | [function] return boolean, 默认真值检测
 *   tip:'检测不通过的提示语' | [string]， 默认提示：'key检测错误'
 *  }]
 * } [boolean]
 * @return boolean //true:通过
 *
 */
import appInfo from 'bjxy-common/helper/getAppInfo'
import login from 'bjxy-common/xyJsBridge/login'

var appinfo = appInfo()


function registerMap (arr = []) {
  var map = {}
  arr.forEach(item => {
    map[item.key] = function (value, slient) {
      if (item.verify ? item.verify.call(this,value) : value) {
        return true
      } else {
        if (!slient) {
          let tip = item.tip || `${item.key}检测错误`
          if(typeof item.tip === 'function'){
            tip = item.tip.call(this,value)
          }
          this.toast(tip)
        }
        return false
      }
    }
  })
  return map
}

export default function ({testRule = []}={}) {
  var MapRule = registerMap(testRule)
  return {
    methods: {
      login (success = function () {}, error = function () {}) {
        if (appinfo.app) {
          login(cb)
        } else {
          var href = location.href
          this.$router.push(
            {name: 'login', query: {callback: cb, callbackHref: href}})
        }
        function cb (json) {
          if (json.errcode == 0) {
            success(json)
          } else {
            error(json)
          }
        }
      },
      //测试数据对象，可选的检测顺序，可选的静默检测
      test (obj, arr, slient) {
        if (typeof arr === 'boolean') {
          slient = arr
          arr = null
        }
        arr = arr || Object.keys(obj)
        return arr.every((key) => {
          if (typeof MapRule[key] === 'function') {
            return MapRule[key].call(this, obj[key], slient)
          } else {
            return true
          }
        })
      },
    },
  }

}
